<template lang="pug">
  header.page-header(:class="headerClass")
    .container
      .row
        div(:class="breadcrumbClass")
          breadcrumbs
        div(:class="pageTitleClass")
          h1.page-header__title(v-if="pageTitle") {{ pageTitle }}
    img.page-header__background(:src='headerBackground', alt='')
</template>

<script>
export default {
  props: {
    pageClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    breadcrumbClass: {
      type: String,
      default: 'col-12',
    },
    breadcrumbOnly: {
      type: Boolean,
      default: false,
    },
    pageTitle: {
      type: String,
      default: null,
    },
    pageTitleClass: {
      type: String,
      default: 'col-12',
    },
    headerBackground: {
      type: String,
      required: true,
    },
  },
};
</script>
